// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  padding: 0px;
}

ion-card {
  padding: 0px;
}

.subTabBox {
  min-width: 170px;
}

.borderit {
  padding: 8px;
}

.appfield {
  min-width: 225px;
}

@media (min-width: 1200px) {
  .appfield {
    min-width: 250px;
  }
}
@media (max-width: 1000px) {
  .subTabBox {
    min-width: 50%;
  }
}
.borderit > div {
  padding: 2px;
  border: 1px solid #c7c7c7;
  border-radius: 10px;
  height: 100%;
}

.iconGenericModels {
  font-size: 1.5rem;
}

ion-card-content {
  padding: 0;
}

.onePageBox {
  max-width: 800px;
  margin: 0 auto;
}

.link {
  text-decoration: underline;
  cursor: pointer;
  color: #111199;
}

.fieldInBox {
  overflow: hidden;
}

.colCardInBox {
  height: auto;
  min-height: 140px;
}

.fieldlable {
  max-width: 140px;
  overflow: hidden;
}

.fieldlableTitle {
  width: 40%;
  overflow: hidden;
}

.fieldlableValue {
  width: 60%;
  overflow: hidden;
}

@media (min-width: 0) and (max-width: 1000px) {
  .fieldlableTitle {
    width: 100%;
  }
  .fieldlableValue {
    width: 100%;
  }
}
.maxHeight {
  height: 100%;
}

.maxWidth {
  max-width: 100%;
}

.maxWidthScroll {
  max-width: 100%;
}

.showOnHover5 .showOnHoverSon5 {
  display: none;
}

.showOnHover5:hover .showOnHoverSon5 {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-box/view-box.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE;IACE,gBAAA;EAHF;AACF;AAMA;EACE;IACE,cAAA;EAJF;AACF;AAOA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EAEE,UAAA;AANF;;AAaA;EACE,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,0BAAA;EACA,eAAA;EACA,cAAA;AAVF;;AAaA;EAGE,gBAAA;AAZF;;AAeA;EACE,YAAA;EACA,iBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,gBAAA;AAZF;;AAeA;EAEE,UAAA;EACA,gBAAA;AAbF;;AAiBA;EACE,UAAA;EACA,gBAAA;AAdF;;AAiBA;EACE;IACE,WAAA;EAdF;EAiBA;IACE,WAAA;EAfF;AACF;AAmBA;EACE,YAAA;AAjBF;;AAqBA;EACE,eAAA;AAlBF;;AAqBA;EACE,eAAA;AAlBF;;AAsBA;EACE,aAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF","sourcesContent":["ion-grid {\n  padding: 0px;\n}\n\nion-card {\n  padding: 0px;\n}\n\n.subTabBox {\n  min-width: 170px;\n  //background-color: var(--ion-color-light);\n}\n\n.swiper {\n}\n\n.borderit {\n  padding: 8px;\n}\n\n.appfield {\n  min-width: 225px;\n}\n\n@media (min-width: 1200px) {\n  .appfield {\n    min-width: 250px;\n  }\n}\n\n@media (max-width: 1000px) {\n  .subTabBox {\n    min-width: 50%;\n  }\n}\n\n.borderit > div {\n  padding: 2px;\n  border: 1px solid #c7c7c7;\n  border-radius: 10px;\n  height: 100%;\n}\n\n.iconGenericModels {\n  font-size: 1.5rem;\n}\n\nion-card-content {\n  //background-color: #efefef;\n  padding: 0;\n}\n\n.colPadding ion-col {\n  //padding: 2px;\n}\n\n.onePageBox {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.link {\n  text-decoration: underline;\n  cursor: pointer;\n  color: #111199;\n}\n\n.fieldInBox {\n  //height: 30px;\n  //max-width: 190px;\n  overflow: hidden;\n}\n\n.colCardInBox {\n  height: auto;\n  min-height: 140px;\n}\n\n.fieldlable {\n  max-width: 140px;\n  overflow: hidden;\n}\n\n.fieldlableTitle {\n  //max-width: 140px;\n  width: 40%;\n  overflow: hidden;\n}\n\n\n.fieldlableValue {\n  width: 60%;\n  overflow: hidden;\n}\n\n@media (min-width: 0) and (max-width: 1000px) {\n  .fieldlableTitle {\n    width: 100%;\n\n  }\n  .fieldlableValue {\n    width: 100%;\n  }\n\n}\n\n.maxHeight {\n  height: 100%;\n  //overflow-y: scroll;\n}\n\n.maxWidth {\n  max-width: 100%;\n}\n\n.maxWidthScroll {\n  max-width: 100%;\n  //overflow-y: scroll;\n}\n\n.showOnHover5 .showOnHoverSon5 {\n  display: none;\n}\n\n.showOnHover5:hover .showOnHoverSon5 {\n  display: block;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
